import { Command } from 'commander'
import { loadConfig, saveConfig } from '../config.js'
import { outputRecord } from '../output.js'

export function registerUse(program: Command): void {
  const useCmd = program.command('use').description('Set default context for subsequent commands')

  useCmd
    .command('workspace <workspaceId>')
    .description('Set the default workspace (files, exec, install, dev commands)')
    .action(async (workspaceId: string) => {
      const config = await loadConfig()
      config.defaultWorkspaceId = workspaceId
      await saveConfig(config)
      console.log(`Default workspace set to ${workspaceId}.`)
    })

  useCmd
    .command('account <accountId>')
    .description('Set the default account (admin commands)')
    .action(async (accountId: string) => {
      const config = await loadConfig()
      config.defaultAccountId = accountId
      await saveConfig(config)
      console.log(`Default account set to ${accountId}.`)
    })

  program
    .command('context')
    .description('Show the current CLI context (API URL, credential kind, defaults)')
    .option('--json', 'output JSON')
    .action(async (options: { json?: boolean }) => {
      const config = await loadConfig()
      outputRecord(
        {
          apiUrl: process.env.VERENTIS_API_URL ?? config.apiUrl ?? '(not set)',
          credential: process.env.VERENTIS_API_KEY ?? config.apiKey ? 'api key' : (process.env.VERENTIS_TOKEN ?? config.identityToken) ? 'identity token' : '(none)',
          defaultWorkspaceId: config.defaultWorkspaceId ?? '(not set)',
          defaultAccountId: config.defaultAccountId ?? '(not set)',
          defaultKey: config.defaultKey ?? '(not set)',
        },
        options,
      )
    })
}
